const INTERNAL_ROUTE_PREFIXES = [
  "/calculator/",
  "/category/",
  "/calculators/",
  "/blog",
  "/about",
  "/disclaimer",
  "/privacy-policy",
  "/terms-and-conditions",
  "/legal",
  "/mortgage-calculator",
];

export function withTrailingSlash(path: string): string {
  if (!path || path === "/") return "/";

  const match = path.match(/^([^?#]*)([?#].*)?$/);
  const pathname = match?.[1] ?? path;
  const suffix = match?.[2] ?? "";
  return `${pathname.endsWith("/") ? pathname : `${pathname}/`}${suffix}`;
}

export function isInternalRoute(path: string): boolean {
  return path === "/" || INTERNAL_ROUTE_PREFIXES.some((prefix) => path === prefix || path.startsWith(prefix));
}

export function canonicalRoute(path: string): string {
  return isInternalRoute(path) ? withTrailingSlash(path) : path;
}

export function canonicalizeInternalLinks(html: string): string {
  return html.replace(/\b(href\s*=\s*)(["'])(\/[^"']*)\2/gi, (_match, prefix, quote, path) => {
    return `${prefix}${quote}${canonicalRoute(path)}${quote}`;
  });
}